import { render, staticRenderFns } from "./AvailabilityBadgeSo.vue?vue&type=template&id=2a7b1732"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports